import { log } from 'log';

import { uniqueId } from 'js/utils/methods.util';

const handlers = {};

export const sendMessage = (id, message, serialize = true) => {
    const handler = handlers[id] || {};
    const { source, origin } = handler;

    const parsedMessage = serialize
        ? JSON.stringify(message)
        : message;

    if (source && origin) {
        source.postMessage(parsedMessage, origin);
    }
};

export const addHandler = ({ origin = '*', source, callback, parse = false }) => {
    const id = uniqueId('postMsgHdr_');

    handlers[id] = {
        origin,
        source,
        callback,
        parse
    };

    return id;
};

export const removeHandler = (id) => {
    delete handlers[id];
};

const parseMessage = (message) => {
    try {
        return typeof message === 'string'
            ? JSON.parse(message)
            : message;

    } catch (e) {
        return e;
    }
};

const handleMessages = ({ data, source, origin }) => {
    try { // Wrapping so CORS errors will not block next messages.
        const currentHandler = Object.values(handlers)
            .find((handler) => source === handler.source || source[0] === handler.source[0]);

        if (currentHandler) {
            const { callback, parse } = currentHandler;
            currentHandler.origin = origin; // update handler with actual origin

            if (typeof callback === 'function') {
                const message = parse ? parseMessage(data) : data;

                if (message instanceof Error) {
                    return callback(data, message);
                }

                callback(message);
            }
        }
    } catch (e) {
        log('error', e);
    }
};

window.addEventListener('message', handleMessages);
